function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaylaVWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.213 99.213",
    style: {
      enableBackground: "new 0 0 99.213 99.213"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M21.927,26.794h12.279c0.878,0,1.121,0.3,1.335,0.802c0.118,0.277,7.39,17.668,7.39,17.668 l-17.694-10.51L21.927,26.794z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "25.633,35.691 43.298,46.146 45.817,52.224 35.181,58.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "35.434,59.07 46.066,52.763 47.678,56.658 41.231,73.042  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M78.619,26.794H66.34c-0.878,0-1.121,0.3-1.335,0.802c-0.118,0.277-7.39,17.668-7.39,17.668 l17.694-10.51L78.619,26.794z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "74.913,35.691 57.248,46.146 54.729,52.224 65.365,58.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "65.112,59.07 54.48,52.763 52.868,56.658 59.315,73.042  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaylaVWhite);
export default __webpack_public_path__ + "static/media/vayla_v_white.a6ce551c1d52aa895363db96a36366ba.svg";
export { ForwardRef as ReactComponent };